import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const EmailAlertModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "EmailAlertModalContainer" */
      './EmailAlertModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
